// Logo constraints (§11.8): PNG only, exactly 320x320, max 10 MB.
export const LOGO_MIME = "image/png"
export const LOGO_DIMENSION_PX = 320
export const MAX_LOGO_BYTES = 10 * 1024 * 1024

// Reads a File's pixel dimensions via an offscreen Image element — no upload
// involved, so this works with the externalOps stub exactly as it will with a
// real one.
export const readImageDimensions = (file) =>
  new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
      URL.revokeObjectURL(objectUrl)
    }
    img.onerror = () => {
      resolve(null)
      URL.revokeObjectURL(objectUrl)
    }
    img.src = objectUrl
  })
